export default __webpack_public_path__ + "23d659590763365b19ee6d9f1d655abd.svg";